export default "__VITE_ASSET__B$19nwhC__"